import React, { useEffect, useState } from "react";

import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useOutstandingRap } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";

const SubProject = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const NumOutstandingRap = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const NumAdditionalPAPs = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const Remarks = {
  xxl: 5,
  xl: 4,
  lg: 4,
  md: 4,
  sm: 0,
  xs: 0,
  style: { whiteSpace: "normal", wordBreak: "break-word", maxWidth: 300 },
};
const RapStatus = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 0, xs: 0 };

const headerLayout = [
  { ...SubProject, header: "Sub-project" },
  { ...NumOutstandingRap, header: "No. of Outstanding RAP" },
  { ...NumAdditionalPAPs, header: "No. of Additional PAPs" },
  { ...RapStatus, header: "RAP Status" },
  { ...Remarks, header: "Remarks" },
];


const RapImplementation = ({ match }) => {
  const {
    params: { packageId, procuringEntityId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { formattedOutstandingRap = [], pagination, loading } = useOutstandingRap(
    procuringEntityId,
    startDate,
    endDate,
    currentPage,
    pageSize
  );
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name; 


  const [drawerVisible, setDrawerVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  const rapData = Array.isArray(formattedOutstandingRap)
    ? formattedOutstandingRap
    : [];

  const openDrawer = (item) => {
    setActiveItem(item);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setActiveItem(null);
  };



  return (
    <>
      <div style={{ width: "100%", padding: "24px" }}>
        <ActionBar
          actionButtonProp={{
            title: `${packageName || "==//=="}: RAP Implementation`,
          }}
        />

        <div className="prst-table">
          <CustomList
            itemName="RAP Implementation"
            items={rapData}
            page={currentPage}
            itemCount={pagination?.total || (rapData?.length ?? 0)}
            loading={loading}
            headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id}
              name={item?.subproject?.name || "==//=="}
              item={item}
              isPackage={false}
              renderActions={() => false}
              onClick={() => openDrawer(item)}
              style={{
                backgroundColor:
                  activeItem?.package_id === item.package_id
                    ? "#f0f0f0"
                    : "transparent",
              }}
            >
              <Col {...SubProject} className="contentEllipse" data-label="Sub-project">
                    {item?.subproject?.name || "==//=="}
              </Col>
              <Col {...NumOutstandingRap} className="contentEllipse" data-label="No. of Outstanding RAP">
                {item?.total_outstanding_RAP ?? "==//=="}
              </Col>
              <Col {...NumAdditionalPAPs} className="contentEllipse" data-label="No. of Additional PAPs">
                {item?.additional_paps ?? "==//=="}
              </Col>
              <Col {...RapStatus} className="contentEllipse" data-label="RAP Status">
                {Array.isArray(item?.RAP_Status)
                  ? item.RAP_Status.map(
                      (status) => `${status.name}(${status.count})`
                    ).join(", ")
                  : "==//=="}
              </Col>
              <Col
                {...Remarks}
                className="contentEllipse"
                data-label="Remarks"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  maxWidth: 300,
                }}
              >
                {item?.remarks?.length > 20 ? item.remarks.slice(0, 20) + "..." : item.remarks || "==//=="}
              </Col>
              
              <div className="view-card-details" onClick={() => openDrawer(item)}>
                View Details
              </div>
            </ListItem>
          )}
          />
        </div>

        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        )}
      </div>

      <Drawer
          title="RAP Implementation Details"
          placement="right"
          closable={true}
          onClose={closeDrawer}
          visible={drawerVisible}
          width={720}
        >
          {activeItem && (
            <div>
              <p>
                <strong>Sub-project:</strong>{" "}
                {activeItem?.subproject?.name || "==//=="}
              </p>
              <p>
                <strong>No. of Outstanding RAP:</strong>{" "}
                {activeItem?.total_outstanding_RAP ?? "==//=="}
              </p>
              <p>
                <strong>No. of Additional PAPs:</strong>{" "}
                {activeItem?.additional_paps ?? "==//=="}
              </p>
              <p>
                <strong>RAP Status:</strong>{" "}
                {Array.isArray(activeItem?.RAP_Status)
                  ? activeItem.RAP_Status.map(
                      (status) => `${status.name}(${status.count})`
                    ).join(", ")
                  : "==//=="}
              </p>
              <p>
                <strong>Remarks:</strong> {activeItem?.remarks || "==//=="}
              </p>
            </div>
          )}
        </Drawer>
    </>
  );
};

export default RapImplementation;
